const DEV_URL = 'https://service-d01.icil.net:8443'
export default {
  BASE_URL: DEV_URL
}
